<template>
    <div id="content">
        <div class="admin-card purchase-result">
            <div class="purchase-icon">
                <i class="bi bi-x-circle"></i>
            </div>
            <h1 class="purchase-title">{{ $t('plans.purchaseCancel.title') }}</h1>
            <p class="purchase-message">{{ $t('plans.purchaseCancel.message') }}</p>
            <div class="purchase-actions">
                <router-link to="/plans-table" class="btn-purple">
                    <i class="bi bi-arrow-left"></i>
                    <span>{{ $t('plans.purchaseCancel.backToPlans') }}</span>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {}
</script>

<style scoped>
.purchase-result {
    max-width: 520px;
    margin: 60px auto 0;
    padding: 36px 28px;
    text-align: center;
}
.purchase-icon {
    font-size: 56px;
    line-height: 1;
    margin-bottom: 18px;
    color: #dc2626;
}
.purchase-title {
    font-size: 22px;
    font-weight: 700;
    color: #0f172a;
    margin: 0 0 10px 0;
}
.purchase-message {
    font-size: 15px;
    color: #475569;
    margin: 0 0 24px 0;
}
.purchase-actions {
    display: inline-flex;
    gap: 10px;
    justify-content: center;
    flex-wrap: wrap;
}
</style>
